import { useMemo } from 'react';

import { ChipLinkBox, InfoField, StacksIcon } from '@occc/ui-design-system';
import { LocationGroupFragment } from '@occc/graphql';
import { routeCreator } from '@occc-app/routes/Location/utils';

type LocationGroupsInfoFieldProps = {
  label?: string;
  locationGroups: LocationGroupFragment[];
};

export const LocationGroupsInfoField = ({
  label,
  locationGroups,
}: LocationGroupsInfoFieldProps) => {
  const chipItems = useMemo(
    () =>
      locationGroups.map((locationGroup) => {
        return {
          label: locationGroup.name,
          href: routeCreator.locationGroupDetails(locationGroup.uuid),
        };
      }),
    [locationGroups],
  );

  return (
    <InfoField
      label={label ?? 'Location Groups'}
      value={<ChipLinkBox items={chipItems} chipIcon={StacksIcon} />}
      disableTypography
    />
  );
};
